document.addEventListener('DOMContentLoaded', () => {
    let lastScrollTop = 0;
    let animating = false;
    let topPosHighlight = 0;
    let heightHighlight = 0;
    let st = 0;

    // highlightScrollDown function
    function highlightScrollDown() {
        animating = true;
        let newScrollPos = topPosHighlight + heightHighlight;

        if (st < newScrollPos) {
            // Modern smooth scroll alternative to jQuery animate
            window.scrollTo({
                top: newScrollPos,
                behavior: 'smooth'
            });

            // Since scrollTo doesn't have a callback, we use a timeout
            setTimeout(() => {
                animating = false;
            }, 1000);
        }
    }

    // updateHighlight function
    function updateHighlight() {
        const container = document.querySelector('.container-highlight');
        topPosHighlight = container.getBoundingClientRect().top + window.scrollY;
        heightHighlight = container.offsetHeight;
    }

    // Initial call to updateHighlight
    updateHighlight();

    // Click event listener for scroll down button
    document.querySelector('.highlight-scroll-down > i').addEventListener('click', () => {
        highlightScrollDown();
    });

    // Resize event listener
    window.addEventListener('resize', () => {
        updateHighlight();
    });

    // Wheel event listener (combining mousewheel and DOMMouseScroll)
    document.addEventListener('wheel', (event) => {
        // Normalize wheel direction (negative is down, positive is up)
        const delta = event.deltaY;

        if (delta <= 0) {
            // Scrolling up - no action needed based on original code
        } else {
            st = window.scrollY || document.documentElement.scrollTop;

            if (st > lastScrollTop) {
                if (!animating) {
                    if ((topPosHighlight + st) > ((topPosHighlight + heightHighlight) * 0.25) &&
                        (st < (topPosHighlight + heightHighlight))) {
                        highlightScrollDown();
                    }
                }
            }
            lastScrollTop = st;
        }
    }, { passive: true });
});